import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import { dashboardLoadPendingOrders, loadSessions } from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(loadSessions.type, send, socket);
  yield takeEvery(dashboardLoadPendingOrders.type, send, socket);
}
